import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Login from "@/pages/Login";
import BoardsList from "@/pages/BoardsList";
import CommunityDashboard from "@/pages/CommunityDashboard";
import PianoEconomico from "@/pages/PianoEconomico";
import Dashboard from "@/pages/Dashboard";
import MeltingPoint from "@/pages/MeltingPoint";
import CommunityDetail from "@/pages/CommunityDetail";
import AdminUsers from "@/pages/AdminUsers";
import AdminDatabase from "@/pages/AdminDatabase";
import AdminSettings from "@/pages/AdminSettings";
import VacantBoards from "@/pages/VacantBoards";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Pricing from "@/pages/Pricing";
import Account from "@/pages/Account";
import Terms from "@/pages/Terms";
import ProtectedRoute from "@/components/ProtectedRoute";
import LockedFeatureDialog from "@/components/LockedFeatureDialog";
import ProfileCompletionModal from "@/components/ProfileCompletionModal";
import GuideLauncher from "@/components/GuideLauncher";
import { Toaster } from "@/components/ui/sonner";

const RootGate = () => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-8 h-8 border-2 border-slate-300 border-t-slate-900 rounded-full animate-spin" />
      </div>
    );
  }
  if (user) return <Navigate to="/dashboard" replace />;
  return <Login />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<RootGate />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><CommunityDashboard /></ProtectedRoute>} />
      <Route path="/piano-economico" element={<ProtectedRoute><PianoEconomico /></ProtectedRoute>} />
      <Route path="/boards" element={<ProtectedRoute><BoardsList /></ProtectedRoute>} />
      <Route path="/boards/:boardId" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/melting-point" element={<Navigate to="/community" replace />} />
      <Route path="/community" element={<ProtectedRoute><MeltingPoint /></ProtectedRoute>} />
      <Route path="/community/:cid" element={<ProtectedRoute><CommunityDetail /></ProtectedRoute>} />
      <Route path="/admin/users" element={<Navigate to="/admin/settings?tab=users" replace />} />
      <Route path="/admin/database" element={<Navigate to="/admin/settings?tab=database" replace />} />
      <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
      <Route path="/donate" element={<Navigate to="/dashboard" replace />} />
      <Route path="/admin/donations" element={<Navigate to="/dashboard" replace />} />
      <Route path="/admin/vacant-boards" element={<ProtectedRoute><VacantBoards /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <AppRouter />
            <LockedFeatureDialog />
            <ProfileCompletionModal />
            <GuideLauncher />
            <Toaster position="top-right" />
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
